import { DictionaryNamesEnum } from '../enums/DictionaryNamesEnum';
import { DictionaryUUIDsEnum } from '../enums/DictionaryUUIDsEnum';

export const dictionaryNameById: Record<DictionaryUUIDsEnum, DictionaryNamesEnum> = {
  [DictionaryUUIDsEnum.ACCEPTED_DOCUMENT]: DictionaryNamesEnum.ACCEPTED_DOCUMENT,
  [DictionaryUUIDsEnum.CHECKLIST]: DictionaryNamesEnum.CHECKLIST,
  [DictionaryUUIDsEnum.EVENT_TYPE]: DictionaryNamesEnum.EVENT_TYPE,
  [DictionaryUUIDsEnum.KNM_KIND]: DictionaryNamesEnum.KNM_KIND,
  [DictionaryUUIDsEnum.DECISION_KIND]: DictionaryNamesEnum.DECISION_KIND,
  [DictionaryUUIDsEnum.KNO_ORGANIZATIONS]: DictionaryNamesEnum.KNO_ORGANIZATIONS,
  [DictionaryUUIDsEnum.PROF_KIND]: DictionaryNamesEnum.PROF_KIND,
  [DictionaryUUIDsEnum.REQUIREMENT]: DictionaryNamesEnum.REQUIREMENT,
  [DictionaryUUIDsEnum.RISK_CATEGORY]: DictionaryNamesEnum.RISK_CATEGORY,
  [DictionaryUUIDsEnum.DANGER_CLASS]: DictionaryNamesEnum.DANGER_CLASS,
  [DictionaryUUIDsEnum.RISK_INDICATORY]: DictionaryNamesEnum.RISK_INDICATORY,
  [DictionaryUUIDsEnum.SUBJECT_TYPE]: DictionaryNamesEnum.SUBJECT_TYPE,
  [DictionaryUUIDsEnum.SUBJECT_KIND]: DictionaryNamesEnum.SUBJECT_KIND,
  [DictionaryUUIDsEnum.SUBJECT_SUB_KIND]: DictionaryNamesEnum.SUBJECT_SUB_KIND,
  [DictionaryUUIDsEnum.SUPERVISION_TYPE]: DictionaryNamesEnum.SUPERVISION_TYPE,
  [DictionaryUUIDsEnum.FEDERAL_LAWS]: DictionaryNamesEnum.FEDERAL_LAWS,
  [DictionaryUUIDsEnum.KNO_LEVELS]: DictionaryNamesEnum.KNO_LEVELS,
  [DictionaryUUIDsEnum.KNM_SUBJECT_TYPES]: DictionaryNamesEnum.KNM_SUBJECT_TYPES,
  [DictionaryUUIDsEnum.POSITIONS]: DictionaryNamesEnum.POSITIONS,
  [DictionaryUUIDsEnum.PERMIT_DOCS]: DictionaryNamesEnum.PERMIT_DOCS,
  [DictionaryUUIDsEnum.PARTICIPANT_POSITIONS]: DictionaryNamesEnum.PARTICIPANT_POSITIONS,
  [DictionaryUUIDsEnum.TARGET_ENTITY]: DictionaryNamesEnum.TARGET_ENTITY,
  [DictionaryUUIDsEnum.KNM_TYPES]: DictionaryNamesEnum.KNM_TYPES,
  [DictionaryUUIDsEnum.ERVK]: DictionaryNamesEnum.ERVK,
  [DictionaryUUIDsEnum.ERVK_CHECK_LIST]: DictionaryNamesEnum.ERVK_CHECK_LIST,
  [DictionaryUUIDsEnum.CONDITION_TYPES]: DictionaryNamesEnum.CONDITION_TYPES,
};
